module.exports = __webpack_public_path__ + "img/services-payments.41864f71.svg";